import { assertNever } from '@varos/util-typescript';
function buildEditorSpan(span) {
    if (span.kind === 'text') {
        const coreAnnotations = span.annotations;
        return {
            kind: 'text',
            text: span.text,
            annotations: {
                bold: coreAnnotations?.bold ?? false,
                italic: coreAnnotations?.italic ?? false,
                underline: coreAnnotations?.underline ?? false,
            },
            href: span.href,
        };
    }
    if (span.kind === 'mention') {
        const coreAnnotations = span.annotations;
        const mentionConfig = span.mention;
        return {
            kind: 'mention',
            text: span.text ?? 'unknown mention',
            annotations: {
                bold: coreAnnotations?.bold ?? false,
                italic: coreAnnotations?.italic ?? false,
                underline: coreAnnotations?.underline ?? false,
            },
            mention: {
                id: mentionConfig.id,
                type: mentionConfig.type,
            },
        };
    }
    if (span.kind === 'reference') {
        return {
            kind: 'reference',
            text: span.id,
            annotations: {
                bold: false,
                italic: false,
                underline: false,
            },
        };
    }
    assertNever(span);
}
function buildEditorNode(block) {
    if (block.data.kind === 'text') {
        return {
            id: block.id,
            kind: 'text',
            content: block.data.items.map(buildEditorSpan),
        };
    }
    if (block.data.kind === 'heading') {
        return {
            id: block.id,
            kind: 'heading',
            content: block.data.items.map(buildEditorSpan),
            level: block.data.level,
        };
    }
    if (block.data.kind === 'list_item') {
        return {
            id: block.id,
            kind: 'list_item',
            content: block.data.items.map(buildEditorSpan),
            style: block.data.style,
        };
    }
    if (block.data.kind === 'divider') {
        return {
            id: block.id,
            kind: 'divider',
        };
    }
    if (block.data.kind === 'callout') {
        return {
            id: block.id,
            kind: 'callout',
            content: [
                {
                    kind: 'text',
                    text: block.data.text,
                    annotations: {
                        bold: false,
                        italic: false,
                        underline: false,
                    },
                    href: null,
                },
            ],
            icon: block.data.icon,
        };
    }
    if (block.data.kind === 'resource' ||
        block.data.kind === 'button' ||
        block.data.kind === 'database_view' ||
        block.data.kind === 'task') {
        return {
            id: block.id,
            kind: 'custom',
            blockType: block.data.kind,
            blockId: block.id,
        };
    }
    if (block.data.kind === 'footnote') {
        return {
            id: block.id,
            kind: 'text',
            content: [
                {
                    kind: 'text',
                    text: 'unsupported "footnote" block',
                    annotations: {
                        bold: false,
                        italic: false,
                        underline: false,
                    },
                    href: null,
                },
            ],
        };
    }
    if (block.data.kind === 'code' ||
        block.data.kind === 'database' ||
        block.data.kind === 'quote') {
        throw new Error(`Unsupported block type: ${block.data.kind}`);
    }
    assertNever(block.data);
}
export function buildEditorState(blocks) {
    return {
        nodes: blocks.map(buildEditorNode),
    };
}
//# sourceMappingURL=editorStateHelper.js.map